import CoreComponent from '../../core/CoreComponent.vue';
import { isMobile } from '@/utils';
export default {
  extends: CoreComponent,
  mounted() {
    const cardImages = this.cmpEl.querySelectorAll('.cmp-ctaBanner__image .cmp-image__image');
    cardImages.forEach(image => {
      const card = image.closest('.cmp-ctaBanner');
      const subCard = image.closest('.cmp-ctaBanner--sub');
      const ctaElement = card?.querySelector('.cmp-ctaBanner__content .cmp-ctaBanner__action-link');
      if (ctaElement) {
        if (subCard) {
          if (!isMobile()) {
            const backGroundImage = subCard.querySelector('.cmp-ctaBanner');
            backGroundImage.style.cursor = 'pointer';
            backGroundImage.addEventListener('click', () => {
              ctaElement.click();
            });
          }
        } else {
          image.style.cursor = 'pointer';
          image.addEventListener('click', () => {
            ctaElement.click();
          });
        }
      }
    });
  }
};